import React from 'react';
import { Phone, MessageCircle, CheckCircle2, Star, ShieldCheck } from 'lucide-react';
import { Button } from './ui/button';
import { company, heroPoints, waLink } from '../mock';
import LeadForm from './LeadForm';

export default function Hero() {
  return (
    <section id="home" className="relative pt-[112px] lg:pt-[130px] pb-16 lg:pb-24 overflow-hidden bg-white">
      <div className="absolute inset-0 hero-glow" />
      <div className="absolute inset-0 bg-grid opacity-60" />
      <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
        {/* Left content */}
        <div>
          <div className="inline-flex items-center gap-2 bg-primary/10 text-primary rounded-full px-4 py-1.5 text-sm font-semibold mb-5">
            <Star className="w-4 h-4 fill-accent text-accent" />
            Trusted by 18,000+ importers & manufacturers
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-[3.4rem] font-extrabold leading-[1.08] text-slate-900 font-display">
            India's Leading <span className="text-primary">Certification</span> & <span className="brand-gradient">Compliance</span> Consultants
          </h1>
          <p className="mt-5 text-lg text-slate-600 max-w-xl">
            End-to-end expert assistance for BIS, ISI, CDSCO, WPC, TEC, Legal Metrology & EPR &mdash; covering documentation, testing coordination and complete compliance support for faster, hassle-free approvals.
          </p>

          <ul className="mt-6 space-y-2.5">
            {heroPoints.map((p) => (
              <li key={p} className="flex items-center gap-3 text-slate-700 font-medium">
                <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0" /> {p}
              </li>
            ))}
          </ul>

          <div className="mt-7 inline-flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-lg px-4 py-2.5 text-sm text-amber-800 font-medium">
            <ShieldCheck className="w-4 h-4" /> 30&ndash;50% faster certification with a 99% approval rate.
          </div>

          <div className="mt-7 flex flex-col sm:flex-row flex-wrap gap-4">
            <Button asChild className="w-full sm:w-auto bg-primary hover:bg-primary/90 text-white font-semibold rounded-full px-7 h-14 text-base shadow-lg shadow-primary/25">
              <a href={`tel:${company.phoneRaw}`}><Phone className="w-5 h-5 mr-2" /> Call Now</a>
            </Button>
            <Button asChild className="w-full sm:w-auto bg-[#25D366] hover:bg-[#1fb457] text-white font-semibold rounded-full px-7 h-14 text-base shadow-lg shadow-green-500/25">
              <a href={waLink()} target="_blank" rel="noreferrer"><MessageCircle className="w-5 h-5 mr-2" /> Chat on WhatsApp</a>
            </Button>
          </div>
        </div>

        {/* Right lead form card */}
        <div className="relative">
          <div className="absolute -top-4 -right-4 w-24 h-24 bg-accent/15 rounded-full blur-2xl" />
          <div className="relative bg-white rounded-2xl shadow-2xl shadow-slate-300/50 border border-slate-100 p-7">
            <LeadForm />
          </div>
        </div>
      </div>
    </section>
  );
}
